import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { GRAPH_ROUTES } from '../constants/routes.constants';
import { appLayoutRoute } from '@/core/router/layouts';

const graphsListRoute = createRoute({
  path: GRAPH_ROUTES.LIST,
  getParentRoute: () => appLayoutRoute,
  component: lazyRouteComponent(() =>
    import('../pages').then(m => ({ default: m.GraphsListPage }))
  ),
});

const graphsRoutes = [graphsListRoute];

export default graphsRoutes;
